import React from 'react';
import { Camera, Info } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="py-6">
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-3 hover:opacity-80 transition-opacity"
          >
            <Camera className="w-7 h-7 text-white" />
            <h1 className="text-white text-2xl font-medium tracking-tight">FrameQuest</h1>
          </button>
          <button
            onClick={() => setShowInfo(!showInfo)}
            className="flex items-center justify-center w-10 h-10 text-gray-400 hover:text-white transition-colors"
            aria-label="Show information"
          >
            <Info className="w-6 h-6" />
          </button>
        </div>

        {showInfo && (
          <div className="mt-6 p-6 bg-[#1e1e1e] rounded-lg border border-[#333333] text-gray-300">
            <h2 className="text-xl font-medium text-white mb-4">About FrameQuest</h2>
            <div className="space-y-4">
              <p>
                FrameQuest offers carefully crafted photography challenges to help you improve your skills
                and push your creative boundaries. Each challenge focuses on a specific aspect of photography,
                from composition to technical mastery.
              </p>
              <p>
                How to use challenges:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Browse challenges by category or search for specific topics</li>
                <li>Read through the technical guidance and creative approach</li>
                <li>Take your time to experiment and practice each technique</li>
                <li>Return to challenges any time to refresh your skills</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;